// Polyfills
import 'es6-object-assign/auto';
import 'core-js/fn/array/includes';
import 'core-js/fn/promise/finally';
import 'intl'; // For Safari 9

import React from 'react';
import ReactDOM from 'react-dom';

import {installFlexGapFallback} from '../lib/flex-gap-support';
import {getEntryForPathname} from './entry-route';
import {initTheme} from '../lib/theme-manager';

import supportedBrowser from '../lib/supported-browser';

import styles from './index.css';

// 初始化全局动态主题色
initTheme();

const appTarget = document.createElement('div');
appTarget.className = styles.app;
document.body.appendChild(appTarget);

installFlexGapFallback(document);

if (supportedBrowser()) {
    const entry = getEntryForPathname(window.location.pathname);
    const entryModule = entry === 'editor' ? import('./render-gui.jsx') : import('./render-portal.jsx');
    entryModule.then(module => module.default(appTarget));

} else {
    import('./render-unsupported-browser.jsx')
        .then(module => module.default(appTarget));
}
